// src/components/MenuLayout.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/Menu.css";
import { getProfile } from "../api/user";
import { getNotifications } from "../api/notifications";

const MenuLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(() => {
    const saved = localStorage.getItem("touch-theme");
    if (saved === "dark") return true;
    if (saved === "light") return false;
    return true;
  });
  const [userName, setUserName] = useState("Touch Prop User");
  const [unreadNotifications, setUnreadNotifications] = useState(0);

  const navItems = [
    { key: "dashboard", label: "داشبورد", icon: "/images/icons/menu-dashboard.svg", path: "/dashboard" },
    { key: "identity", label: "احراز هویت", icon: "/images/icons/menu-verify.svg", path: "/identity" },
    { key: "challenges", label: "چالش های من", icon: "/images/icons/menu-competition.svg", path: "/challenges" },
    { key: "competitions", label: "مسابقات", icon: "/images/icons/menu-competition.svg", path: "/competitions" },
    { key: "finance", label: "کیف پول", icon: "/images/icons/menu-finance.svg", path: "/wallet" },
    { key: "orders", label: "سفارشات کاربر", icon: "/images/icons/menu-orders.svg", path: "/orders" },
    { key: "certs", label: "سرتیفیکت ها", icon: "/images/icons/menu-verify.svg", path: "/certificates" },
    { key: "profile", label: "حساب کاربری", icon: "/images/icons/menu-user.svg", path: "/profile" },
    { key: "withdraw", label: "برداشت سود", icon: "/images/icons/menu-profit.svg", path: "/withdraw" },
    { key: "tickets", label: "تیکت ها", icon: "/images/icons/menu-tickets.svg", path: "/tickets" },
    { key: "rules", label: "قوانین", icon: "/images/icons/menu-rules.svg", external: "https://touchprop.com/newrules/" },
    { key: "plans", label: "پلن ها", icon: "/images/icons/menu-plans.svg", path: "/plans" },
    { key: "affiliate", label: "همکاری در فروش", icon: "/images/icons/menu-affiliate.svg", path: "/affiliate" },
    { key: "downloads", label: "دانلودها", icon: "/images/icons/menu-plans.svg", path: "/downloads" },
  ];

  const isActive = (path) => path && location.pathname === path;
  const handleNav = (item) => {
    if (item?.external) {
      window.open(item.external, "_blank", "noopener");
      return;
    }
    if (item?.path) navigate(item.path);
  };

  useEffect(() => {
    const hasToken = !!localStorage.getItem("access_token");
    if (!hasToken) {
      navigate("/login", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const loadProfile = async () => {
      try {
        const data = await getProfile();
        const fullName = data?.full_name || data?.user?.full_name;
        const email = data?.email || data?.user?.email || "";
        const fallbackFromEmail = email ? email.split("@")[0].replace(/[._-]+/g, " ").trim() : "";
        setUserName(fullName || fallbackFromEmail || "Touch Prop User");
      } catch {
        // silent fail
      }
    };
    loadProfile();
  }, []);

  useEffect(() => {
    const loadUnreadCount = async () => {
      try {
        const data = await getNotifications();
        setUnreadNotifications(Number(data?.unread_count || 0));
      } catch {
        setUnreadNotifications(0);
      }
    };
    loadUnreadCount();
    window.addEventListener("touch-notifications-updated", loadUnreadCount);
    return () => window.removeEventListener("touch-notifications-updated", loadUnreadCount);
  }, []);

  useEffect(() => {
    const cls = "theme-dark";
    if (darkMode) {
      document.body.classList.add(cls);
      localStorage.setItem("touch-theme", "dark");
    } else {
      document.body.classList.remove(cls);
      localStorage.setItem("touch-theme", "light");
    }
  }, [darkMode]);

  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/login", { replace: true });
  };

  return (
    <div className="dash-wrapper" dir="rtl">
      <aside className="dash-sidebar">
        <div className="dash-sidebar-logo">
          <img
            src={darkMode ? "/images/touch-prop-logo-dark.png" : "/images/touch-prop-logo.png"}
            alt="User"
            className="dash-logo-img"
          />
        </div>

        <div className="dash-sidebar-panel">
          <nav className="dash-nav">
            {navItems.map((item) => (
              <button
                key={item.key}
                className={`dash-nav-item ${item.key === "plans" ? "dash-nav-item-plans" : ""} ${isActive(item.path) ? "dash-nav-item-active dash-nav-item-highlight" : ""}`}
                onClick={() => handleNav(item)}
              >
                <span className="dash-nav-text">{item.label}</span>
                <span className="dash-nav-icon">
                  <img src={item.icon} alt={item.label} />
                </span>
              </button>
            ))}

            <button className="dash-nav-item dash-nav-logout" onClick={handleLogout}>
              <span className="dash-nav-text dash-nav-logout-text">خروج</span>
              <span className="dash-nav-icon">
                <img src="/images/icons/menu-logout.svg" alt="خروج" />
              </span>
            </button>
          </nav>

          <div className="dash-sidebar-support">
            <div className="dash-sidebar-support-box">
              <div className="dash-support-text">
                <div className="dash-support-title">همراه ما باشید!</div>
                <div className="dash-support-subtitle">پاسخگوی شما هستیم</div>
              </div>

              <button className="dash-support-phone">
                <span className="dash-support-phone-icon">📞</span>
                <span className="dash-support-phone-number">989991959530+</span>
              </button>
            </div>
          </div>
        </div>
      </aside>

      <main className="dash-main">
        <header className="dash-topbar">
          <div className="dash-topbar-left">
            <div className="dash-top-icons-group">
              <button className="dash-top-icon dash-top-icon-bell" onClick={() => navigate("/notifications")}>
                <img src="/images/icons/top-bell.svg" alt="اعلان ها" className="dash-top-icon-img" />
                {unreadNotifications > 0 && (
                  <span className="dash-badge">
                    {unreadNotifications > 99 ? "۹۹+" : unreadNotifications.toLocaleString("fa-IR")}
                  </span>
                )}
              </button>
              <button className="dash-top-icon dash-top-icon-sun" onClick={() => setDarkMode((v) => !v)}>
                <img src="/images/icons/top-sun.svg" alt="تم" className="dash-top-icon-img" />
              </button>
            </div>

            <div className="dash-user-box" role="button" tabIndex={0} onClick={() => navigate("/profile")}>
              <span className="dash-user-name">{userName}</span>
              <span className="dash-user-icon">
                <img src="/images/icons/top-user.svg" alt="UcOO?OO?" />
              </span>
            </div>
          </div>
        </header>

        {children}
      </main>
    </div>
  );
};

export default MenuLayout;
